export const darkTheme = {
  bg: "#121212",
  text_primary: "#ffffff",
  text_secondary: "#b0b0b0",
  card: "#1e1e1e",
  primary: "#0047ab", // Dark Blue
  shadow: "rgba(0, 48, 115, 0.4)", // Blue shadow
  shadowHover: "rgba(0, 78, 187, 0.6)", // Stronger blue hover shadow
};

export const lightTheme = {
  bg: "#f5f5f5",
  text_primary: "#000000",
  text_secondary: "#4f4f4f",
  card: "#ffffff",
  primary: "#0047ab", // Same Blue
  shadow: "rgba(0, 71, 171, 0.2)", // Softer blue shadow
  shadowHover: "rgba(0, 71, 171, 0.4)", // Medium blue hover effect
};
